import App from './App.vue';

export default {
  path: '/CDS_VF_ChronologyList',
  name: 'CDS_VF_ChronologyList',
  component: App,
  meta: {
    pageProperty: {
      title: 'クロノロジー',
      controller: 'CDS_CTR_ChronologyList',
    },
  },
};
